/* eslint-disable quotes, quote-props, comma-dangle */

/**
 * This file is regenerated by generate-api-constants.js
 * Do not edit it manually.
 * Last generated Thu Aug 29 2019 20:12:49 GMT-0700 (Mexican Pacific Standard Time)
 * */

export const COUNTRY_CODE_TO_NAME = {
  USA: 'United States',
  CAN: 'Canada',
  GBR: 'United Kingdom',
  AUS: 'Australia',
  SGP: 'Singapore',
  HKG: 'Hong Kong',
  ARE: 'United Arab Emirates',
  ZAF: 'South Africa',
  NZL: 'New Zealand',
  NLD: 'Netherlands',
  IRL: 'Ireland',
  NOR: 'Norway',
  SWE: 'Sweden',
  THA: 'Thailand',
  DEU: 'Germany',
  MYS: 'Malaysia',
  FRA: 'France',
  ITA: 'Italy',
  ESP: 'Spain',
  AUT: 'Austria',
  CHE: 'Switzerland',
  PRT: 'Portugal',
  DNK: 'Denmark',
  PHL: 'Philippines',
  IDN: 'Indonesia',
  CHN: 'China',
  IND: 'India',
  JPN: 'Japan',
  KWT: 'Kuwait',
  SAU: 'Saudi Arabia',
  ISR: 'Israel',
  MEX: 'Mexico',
  BRA: 'Brazil',
  ARG: 'Argentina',
  COL: 'Colombia',
  BEL: 'Belgium',
  HUN: 'Hungary',
  TWN: 'Taiwan',
  CZE: 'Czech Rep',
  TUR: 'Turkey',
  FIN: 'Finland',
  PER: 'Peru',
  CHL: 'Chile',
  GRC: 'Greece',
  VNM: 'Vietnam',
  RUS: 'Russia',
  KOR: 'South Korea',
  EGY: 'Egypt',
  POL: 'Poland',
};

export const COUNTRY_CODE_TO_SHORT_CODE = {
  USA: 'US',
  CAN: 'CA',
  GBR: 'GB',
  AUS: 'AU',
  SGP: 'SG',
  HKG: 'HK',
  ARE: 'AE',
  ZAF: 'ZA',
  NZL: 'NZ',
  NLD: 'NL',
  IRL: 'IE',
  NOR: 'NO',
  SWE: 'SE',
  THA: 'TH',
  DEU: 'DE',
  MYS: 'MY',
  FRA: 'FR',
  ITA: 'IT',
  ESP: 'ES',
  AUT: 'AT',
  CHE: 'CH',
  PRT: 'PT',
  DNK: 'DK',
  PHL: 'PH',
  IDN: 'ID',
  CHN: 'CN',
  IND: 'IN',
  JPN: 'JP',
  KWT: 'KW',
  SAU: 'SA',
  ISR: 'IL',
  MEX: 'MX',
  BRA: 'BR',
  ARG: 'AR',
  COL: 'CO',
  BEL: 'BE',
  HUN: 'HU',
  TWN: 'TW',
  CZE: 'CZ',
  TUR: 'TR',
  FIN: 'FI',
  PER: 'PE',
  CHL: 'CL',
  GRC: 'GR',
  VNM: 'VN',
  RUS: 'RU',
  KOR: 'KR',
  EGY: 'EG',
  POL: 'PL',
};
